<div class="layer-control form-control-sm form-control">
  <mode-layer-options-menu
    [markType]="markType"
    [model]="renderModel"
    [encoding]="encoding"
    [seriesField]="series?.field"
    (optionsChanged)="onLayerOptionsChanged($event)"
  ></mode-layer-options-menu>
  <div
    class="mark-control form-control form-control-sm"
    [class.open-focus]="isMarkTypeMenuOpen"
    [matMenuTriggerFor]="seriesMenu"
    (menuOpened)="isMarkTypeMenuOpen = true"
    (menuClosed)="isMarkTypeMenuOpen = false"
  >
    <div class="display-text">{{ dropdownText }}</div>
    <capra-icon class="select-icon" icon="icon-caret-down"></capra-icon>
  </div>
</div>
<mat-menu #seriesMenu="matMenu" class="select-menu marks-select-menu">
  <button mat-menu-item (click)="setMarkType('automatic')"><capra-icon></capra-icon>Automatic</button>
  <button *ngFor="let type of supportedMarkTypes" mat-menu-item (click)="setMarkType(type)">
    <capra-icon [icon]="iconMarkMap[type]"></capra-icon>{{ type }}
  </button>
</mat-menu>
